<gtd-card>
  <span card-header>{{ headerText }}</span>
  <div class="card-info">
    <ng-content></ng-content>
  </div>
</gtd-card>
